import { render, staticRenderFns } from "./DetailFigureTable.vue?vue&type=template&id=7439fc7e&scoped=true"
import script from "./DetailFigureTable.vue?vue&type=script&lang=js"
export * from "./DetailFigureTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7439fc7e",
  null
  
)

export default component.exports